import { useCallback, useEffect } from 'react'

import slider01 from 'assets/img/onboarding01.png'
import slider02 from 'assets/img/onboarding02.png'
import slider03 from 'assets/img/onboarding03.png'
import { ActionIconEnum } from 'enums/ActionIcon'
import { PageTitles } from 'enums/PageTitles'
import { TagEventsEnum } from 'enums/TagEvents'
import { useNavBar } from 'hooks/useNavBar'
import { Icons } from 'utils/icons'
import BaseBridge from 'config/bridge/BaseBridge'

import { Carousel } from '@interco/inter-ui/components/Carousel'
import { Text } from '@interco/inter-ui/components/Text'
import { Flex } from '@interco/inter-ui/components/Flex'
import { Button } from '@interco/inter-ui/components/Button'

import * as S from './HowUse.styles'
import { AnalyticsHowUse } from './HowUse.tags'

export const HowUse = () => {
  useNavBar({
    navbarTitle: PageTitles.HOW_USE,
    actionIcons: {
      leftIcon: ActionIconEnum.BACK,
      rightIcon: ActionIconEnum.CLOSE,
    },
  })

  useEffect(() => {
    AnalyticsHowUse(TagEventsEnum.PET_FLOW)
  }, [])

  interface ISliderData {
    id: number
    heroSrc: string
    heroTitle: string
    icon1: JSX.Element
    title1: string
    description1: string
    icon2: JSX.Element
    title2: string
    description2: string
    link?: string
  }

  const icons = {
    slide1Icon1: <Icons.Smartphone color="var(--gray500)" />,
    slide1Icon2: <Icons.Clock color="var(--gray500)" />,
    slide2Icon1: <Icons.Store color="var(--gray500)" />,
    slide2Icon2: <Icons.SimCard color="var(--gray500)" />,
    slide3Icon1: <Icons.CalendarClock color="var(--gray500)" />,
    slide3Icon2: <Icons.Wallet color="var(--gray500)" />,
  }

  const sliderData: ISliderData[] = [
    {
      id: 1,
      heroSrc: slider01,
      heroTitle: 'Cadastre-se no app da Petlove',
      icon1: icons.slide1Icon1,
      title1: 'Acesse o Espaço do cliente',
      description1:
        'Entre no site ou app da Petlove para encontrar todas as informações e serviços disponíveis.',
      icon2: icons.slide1Icon2,
      title2: 'Confira o prazo das carências',
      description2:
        'Cheque os períodos de carência do seu pet. E lembre-se: é possível antecipar uma carência se precisar.',
    },
    {
      id: 2,
      heroSrc: slider02,
      heroTitle: 'Escolha uma clínica credenciada',
      icon1: icons.slide2Icon1,
      title1: 'Consulte a rede credenciada',
      description1:
        'Encontre a clínica mais próxima de você em "Meus Seguros” no super app do Inter ou no aplicativo da Petlove.',
      icon2: icons.slide2Icon2,
      title2: 'Sem microchip',
      description2:
        'Lembre-se: no Plano Pet do Inter não é necessário microchipar seu pet para utilizar o serviço.',
    },
    {
      id: 3,
      heroSrc: slider03,
      heroTitle: 'Visite a clínicia escolhida',
      icon1: icons.slide3Icon1,
      title1: 'Marque uma consulta ou exame',
      description1:
        'A clínica credenciada escolhida utilizará o número de seu CPF para consultar o histórico do seu pet.',
      icon2: icons.slide3Icon2,
      title2: 'Pague a coparticipação',
      description2:
        'Depois da consulta, você pagará apenas a coparticipação do procedimento. Saiba o valor no app da Petlove.',
      link: 'https://saude.petlove.com.br/',
    },
  ]

  const openPetlove = useCallback(() => {
    BaseBridge.openDeepLink('https://saude.petlove.com.br/')
  }, [])

  return (
    <S.Container>
      <S.Slider>
        <Carousel
          dots
          arrows={false}
          infinite={false}
          speed={800}
          slidesToShow={1}
          dotsType="medium"
          verticalMode={false}
          className="slider"
        >
          {sliderData.map((item) => (
            <S.SliderContentWrapper key={item.id}>
              <figure>
                <img
                  src={item.heroSrc}
                  alt="Imagem mostra a passo a passo de como usar o plano pet"
                />
              </figure>

              <S.SliderContent>
                <Text variant="headline-h1" as="h1" semiBold>
                  {item.heroTitle}
                </Text>
                <Flex direction="row" gap="16px" style={{ marginTop: '24px' }}>
                  <Text variant="caption-1">{item.icon1}</Text>
                  <Flex direction="column">
                    <Text variant="caption-1" bold color="var(--gray500)">
                      {item.title1}
                    </Text>
                    <Text variant="caption-1">{item.description1}</Text>
                  </Flex>
                </Flex>
                <Flex direction="row" gap="16px" style={{ marginTop: '32px' }}>
                  <Text variant="caption-1">{item.icon2}</Text>
                  <Flex direction="column">
                    <Text variant="caption-1" bold color="var(--gray500)">
                      {item.title2}
                    </Text>
                    <Text variant="caption-1">{item.description2}</Text>
                  </Flex>
                </Flex>
                {item.link && (
                  <Button
                    style={{ padding: '0', marginTop: '24px', fontSize: '12px' }}
                    variant="link"
                    href={item.link}
                    onClick={openPetlove}
                  >
                    Acessar Espaço do cliente
                  </Button>
                )}
              </S.SliderContent>
            </S.SliderContentWrapper>
          ))}
        </Carousel>
      </S.Slider>
    </S.Container>
  )
}
